import React, { Component } from 'react';
import CurrencyInput from 'react-currency-input';

class InputCurrency extends Component {
    render() {
        const { props } = this;
        return (
            <CurrencyInput 
                {...props} 
                className={`ant-input ${props.disabled ? 'ant-input-disabled':''}`}
                decimalSeparator="," 
                thousandSeparator="."
                prefix="R$ "
            />
        )
    }
}

export const currency2Float = (value) => {
    if (typeof value !== 'string') return value;
    if (value === '') return 0;

    let isNegative = value[0] === '-';
    let tmp = value.replace(/\D+/g, "");
    
    if (tmp.length < 2) {
        return isNegative ? -parseFloat("0." + tmp) : parseFloat("0." + tmp);
    }

    let result = parseFloat(tmp.substr(0, tmp.length - 2) + "." + tmp.substr(-2));
    return isNegative ? -result : result;
}

export const toBRL = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return value;
    // Locale-independent BRL formatting: always 2 decimals, '.' thousands,
    // ',' decimal. Avoids relying on Intl/toLocaleString honoring the 'pt-BR'
    // locale (not guaranteed in older bundles) and avoids the default
    // maximumFractionDigits of 3 that rendered values like 48974.959 as
    // "48.974,959" instead of "48.974,96".
    var negative = value < 0;
    var fixed = Math.abs(value).toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (negative ? '-' : '') + intPart + ',' + parts[1];
}

export default InputCurrency;